import axios from "axios";

export default {
    getClients() {
        return axios.get(`/clients`);
    },
    putClient(id, obj) {
        return axios.put(`/clients/${id}`, obj);
    },

    deleteClient(id) {
        return axios.delete(`/clients/${id}`);
    },
    getExistingClient(email) {
        return axios.post(`/client/exist`, { email: email});
    },
};
